import { api } from "@/api/client";
import type { PromptVersionDetail, PromptView } from "@/types/api";

export interface PromptCreate {
  role: string;
  title: string;
  body: string;
  params?: Record<string, unknown> | null;
  changelog?: string | null;
}

export interface PromptVersionCreate {
  body: string;
  params?: Record<string, unknown> | null;
  changelog?: string | null;
  activate?: boolean;
}

export async function listPrompts(): Promise<PromptView[]> {
  const { data } = await api.get<PromptView[]>("/prompts");
  return data;
}

export async function getPrompt(id: number): Promise<PromptView> {
  const { data } = await api.get<PromptView>(`/prompts/${id}`);
  return data;
}

export async function createPrompt(body: PromptCreate): Promise<PromptView> {
  const { data } = await api.post<PromptView>("/prompts", body);
  return data;
}

export async function getPromptVersion(
  id: number,
  versionNo: number,
): Promise<PromptVersionDetail> {
  const { data } = await api.get<PromptVersionDetail>(
    `/prompts/${id}/versions/${versionNo}`,
  );
  return data;
}

export async function createPromptVersion(
  id: number,
  body: PromptVersionCreate,
): Promise<PromptVersionDetail> {
  const { data } = await api.post<PromptVersionDetail>(
    `/prompts/${id}/versions`,
    body,
  );
  return data;
}

export async function activatePromptVersion(
  id: number,
  versionNo: number,
): Promise<PromptView> {
  const { data } = await api.post<PromptView>(
    `/prompts/${id}/versions/${versionNo}/activate`,
  );
  return data;
}
